"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCall = exports.callBackendFn = exports.parseParams = void 0;
var react_1 = require("react");
var firebaseConf_1 = require("utils/firebaseConf");
var parseParams = function (params) { return JSON.parse(JSON.stringify(params)); };
exports.parseParams = parseParams;
function callBackendFn(fnName, params) {
    var fn = firebaseConf_1.functions.httpsCallable(fnName);
    if (!params) {
        return function (p) {
            analytics.track("calling-".concat(fnName), {
                path: window.location.pathname,
                // eslint-disable-next-line no-underscore-dangle
                callValues: p,
            });
            return fn(p);
        };
    }
    analytics.track("calling-".concat(fnName), {
        path: window.location.pathname,
        // eslint-disable-next-line no-underscore-dangle
        callValues: params,
    });
    return fn(params);
}
exports.callBackendFn = callBackendFn;
var useCall = function (fnName, fixedParams, loaderDelay) {
    var _a = __read((0, react_1.useState)(false), 2), isLoading = _a[0], setIsLoading = _a[1];
    var _b = __read((0, react_1.useState)(), 2), error = _b[0], setError = _b[1];
    var isUnmounted = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(function () { return function () {
        isUnmounted.current = true;
    }; }, []);
    var callFn = function (p) { return function () { return __awaiter(void 0, void 0, void 0, function () {
        var value, combinedParams, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (isLoading)
                        return [2 /*return*/, null];
                    if (!isUnmounted.current)
                        setIsLoading(true);
                    value = null;
                    combinedParams = (typeof p !== 'object' && typeof p !== 'undefined' && p)
                        || (typeof fixedParams !== 'object' && typeof fixedParams !== 'undefined' && fixedParams)
                        || ((p || fixedParams) && __assign(__assign({}, p), fixedParams));
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, , 7]);
                    if (error) {
                        setError(null);
                    }
                    if (!combinedParams) return [3 /*break*/, 3];
                    return [4 /*yield*/, callBackendFn(fnName, combinedParams)];
                case 2:
                    value = _a.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, callBackendFn(fnName)()];
                case 4:
                    value = _a.sent();
                    _a.label = 5;
                case 5: return [3 /*break*/, 7];
                case 6:
                    e_1 = _a.sent();
                    setError(e_1);
                    return [3 /*break*/, 7];
                case 7:
                    if (!isUnmounted.current) {
                        if (loaderDelay) {
                            setTimeout(function () { return setIsLoading(false); }, loaderDelay);
                        }
                        else {
                            setIsLoading(false);
                        }
                    }
                    return [2 /*return*/, value];
            }
        });
    }); }; };
    return [callFn, isLoading, error];
};
exports.useCall = useCall;
